(function () {
    'use strict';

    // @ngInject
    function SourceLeadModalControllerCtor($injector, $scope, $modalInstance, AnalyticsService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SourceLeadModalController';

        this.$modalInstance = $modalInstance;

        AnalyticsService.trackPageView(this, 'source lead modal');
    }

    Controllers.SourceLeadModalController = Class(Controllers.BaseController, {
        constructor: SourceLeadModalControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        }

    });
}());